import {
  SAVE_CHAT_STYLES,
} from '../constants/chat-drag';

export const saveChatStylesAfterDrag = (payload) => ({
  type: SAVE_CHAT_STYLES,
  payload
});
